import { Constants } from "./constants";

export class Notesdata {
    public description:String ="";
    public rectangle:String ="";
    public title:String ="";
}


// WEBPACK FOOTER //
// ./src/app/shared/models/Notesdata.ts